import { makeAutoObservable } from 'mobx';
import { CustomerDetailsInterface, MemberInputInterface } from '../../interfaces/CustomerInterface';

// Initial state for new customer
const initialCustomerState: CustomerDetailsInterface = {
  profileImage: '',
  firstName: '',
  lastName: '',
  companyName: '',
  email: '',
  phone: '',
  address: '',
  status: undefined,
  projectId: '',
  companyId: '',
  id: ''
};

// Initial state for member input
const initialMemberInputState: MemberInputInterface = {
  name: '',
  role: 1,
  title: '',
  email: ''
};

export class CustomerStore {
  loading = false;
  customers: CustomerDetailsInterface[] = [];
  newCustomer: CustomerDetailsInterface = initialCustomerState;
  individualCustomer: CustomerDetailsInterface = { ...initialCustomerState };
  memberInput: MemberInputInterface = initialMemberInputState;
  customerMembers: MemberInputInterface[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  // Set loading state
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  // Set customer list
  setCustomers(customers: CustomerDetailsInterface[]) {
    this.customers = customers;
  }

  // Set customer detail
  setCustomerDetail(customer: CustomerDetailsInterface) {
    this.newCustomer = { ...(customer || initialCustomerState) };
  }

  // Update customer detail property
  updateCustomerDetail(propsName: string, value: string | number | undefined) {
    (this.newCustomer as unknown as { [key: string]: string | number | undefined })[propsName] = value;
  }

  // Clear customer detail
  clearCustomerDetail() {
    this.newCustomer = { ...initialCustomerState };
  }

  // Set individual customer detail
  setIndividualCustomerDetail(customer: Partial<CustomerDetailsInterface>) {
    this.individualCustomer = { ...initialCustomerState, ...customer };
  }

  // Set member input
  setMemberInput(input: MemberInputInterface) {
    this.memberInput = { ...(input || initialMemberInputState) };
  }

  // Update member input property
  updateMemberInput(propsName: string, value: string | number | undefined) {
    (this.memberInput as unknown as { [key: string]: string | number | undefined })[propsName] = value;
  }

  // Clear member input
  clearMemberInput() {
    this.memberInput = { ...initialMemberInputState };
  }

  // Set customer members
  setCustomerMembers(members: MemberInputInterface[]) {
    this.customerMembers = members;
  }

  // Clear all customer data
  clearAllCustomerData() {
    this.loading = false;
    this.customers = [];
    this.newCustomer = { ...initialCustomerState };
    this.individualCustomer = { ...initialCustomerState };
    this.memberInput = { ...initialMemberInputState };
    this.customerMembers = [];
  }
}
